import { AddNewCounterpartyDialog } from '@/features/ap_counterparties/components/AddNewCounterpartyDialog';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback, useState } from 'react';

export const ApCounterparties: FC = memo(() => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <ButtonV2 onClick={() => setOpen(true)}>
        {t('counterparty_add_new_button')}
      </ButtonV2>
      <AddNewCounterpartyDialog
        title={t('counterparty_add_new_dialog_title')}
        open={open}
        onClose={onClose}
      />
    </>
  );
});
ApCounterparties.displayName = 'ApCounterparties';
